import { render } from "./WelcomeWhatsappDialog.vue?vue&type=template&id=55cb34f4&scoped=true"
const script = {}

import "./WelcomeWhatsappDialog.vue?vue&type=style&index=0&id=55cb34f4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55cb34f4"]])

export default __exports__